import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Box from '@rexlabs/box';
import { useStyles, StyleSheet, text, padding, icon, mq, transition } from '@rexlabs/styling';
import Icons from '@rexlabs/icons';
import { Breakpoints } from '@rexlabs/breakpoints';
import { MaybeLink } from './maybe-link';
import { useNavigation } from '../../context';
import { WIDTHS } from '../../utils/constants';
var ChevronRight = Icons.ChevronRight;
var defaultStyles = StyleSheet({
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: function height(_ref) {
      var token = _ref.token;
      return token('navigation.item.icon.size', '2rem');
    },
    width: function width(_ref2) {
      var token = _ref2.token;
      return token('navigation.item.icon.size', '2rem');
    },
    '& > svg': _objectSpread({}, icon.styles({
      target: 'navigation.item',
      size: 'l'
    }))
  },
  label: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    position: 'absolute',
    left: '-2rem',
    opacity: 0,
    whiteSpace: 'nowrap',
    pointerEvents: 'none'
  }, transition.styles.combine({
    target: 'navigation.item',
    presets: [{
      property: 'opacity',
      duration: 'medium',
      easing: 'smooth'
    }, {
      property: 'left',
      duration: 'medium',
      easing: 'smooth'
    }]
  })), text.styles({
    target: 'navigation.item',
    fallback: 'normal.default'
  })), padding.styles({
    target: 'navigation.item',
    left: function left(_ref3) {
      var token = _ref3.token;
      return token('navigation.menu.width', WIDTHS.MENU.DESKTOP);
    }
  })), mq.styles.combine([{
    queries: {
      maxWidth: 's'
    },
    styles: {
      left: 0,
      opacity: 1,
      pointerEvents: 'all'
    }
  }, {
    queries: {
      minWidth: 's',
      maxWidth: 'm'
    },
    styles: {
      left: 0,
      opacity: 1,
      pointerEvents: 'all'
    }
  }])),
  labelExpanded: {
    left: 0,
    opacity: 1,
    pointerEvents: 'all'
  }
});
export function Item(_ref4) {
  var id = _ref4.id,
      label = _ref4.label,
      to = _ref4.to,
      subItems = _ref4.subItems,
      activeMatches = _ref4.activeMatches,
      attributes = _ref4.attributes,
      Icon = _ref4.Icon;
  var s = useStyles(defaultStyles);

  var _useNavigation = useNavigation(),
      activeItem = _useNavigation.activeItem,
      isExpanded = _useNavigation.isExpanded;

  return /*#__PURE__*/React.createElement(MaybeLink, {
    id: id,
    to: to,
    label: label,
    subItems: subItems,
    activeMatches: activeMatches,
    attributes: attributes
  }, /*#__PURE__*/React.createElement(Box, _extends({}, s('icon'), {
    alignItems: "center",
    justifyContent: "center"
  }), /*#__PURE__*/React.createElement(Icon, {
    size: "l"
  })), /*#__PURE__*/React.createElement(Box, _extends({}, s('label', {
    labelExpanded: activeItem || isExpanded
  }), {
    alignItems: "center"
  }), label), !to && /*#__PURE__*/React.createElement(Breakpoints, {
    queries: {
      maxWidth: 'm'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(ChevronRight, {
    size: "m"
  }))));
}